import React, {
    useEffect,
    useRef,
    useState
} from "react";
import {
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    useIonRouter
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import {
    americanFootballOutline,
    homeOutline,
    trophyOutline,
    personCircleOutline
} from "ionicons/icons";
import {
    AUTH_CHANGED_EVENT,
    isAuthenticated
} from "../services/auth";

import { Redirect, Route } from "react-router-dom";

import HomePage from "./Home";
import TournmentPage from "./Tournment";
import LogPage from "./LogIn";
import AccountPage from "./Account";
import FantasyLeaguePage from "./FantasyLeague";
import FantasyTeamPage from "./FantasyTeam";
import FantasySettingsMenuPage from "./FantasySettingsMenu";
import FantasyPointSettingsPage from "./FantasyPointSettings";
import TeamSettingsPage from "./TeamSettings";
import CreateLeaguePage from "./CreateLeague";
import ResPage from "./Results";
import FantasyPage from "./Fantasy";
import CalendarPage from "./Calendar";
import StatResPage from "./ResultStats";
import StatTeamResPage from "./ResultStatsTeam";
import GamePage from "./Game";
import GamePlaysPage from "./GamePlays";
import GamePlayersPage from "./GamePlayers";
import GameStatsPage from "./GameStats";
import TeamPage from "./Team";
import TeamTablePage from "./TeamTable";
import TeamStatsPage from "./TeamStats";
import TeamStatsTeamPage from "./TeamStatsTeam";
import TeamRosterPage from "./TeamRoster";
import SearchPage from "./Search";
import PlayerPage from "./Player";
import StatsPlayerPage from "./PlayerStats";
import FantasyDraftPage from "./FantasyDraft";
import FantasyGamePage from "./FantasyGame";
import FantasySettingsPage from "./FantasyLeagueSettings";
import FantasyProjectionsPage from "./FantasyProjections";
import FantasyPlayersPage from "./FantasyPlayers";
import FantasyDropPlayersPage from "./FantasyDropPlayers";
import FantasyTopPlayersPage from "./FantasyTopPlayers";
import FantasyCommissionerTeamSettingsPage from "./FantasyCommissionerTeamSettings";
import FantasyDraftSettingsPage from "./FantasyDraftSettings";
import FantasyCommissionerTradesPage from "./FantasyCommissionerTrades";
import FantasyScheduleSettingsPage from "./FantasyScheduleSettings";

import "./Tabs.css";

const TabsContent: React.FC = () => {
    const router = useIonRouter();

    const [loggedIn, setLoggedIn] = useState(
        function () {
            return isAuthenticated();
        }
    );

    /*
        Conserva el estado anterior para detectar únicamente
        la transición: sesión activa → sesión expirada.
    */
    const previousLoggedInRef = useRef(loggedIn);

    useEffect(
        function () {
            function syncAuthentication(): void {
                setLoggedIn(isAuthenticated());
            }

            /*
                Las cookies no emiten un evento propio al vencer.
                Esta revisión detecta el timeout de sesión.
            */
            const intervalId = window.setInterval(
                syncAuthentication,
                5000
            );

            window.addEventListener(
                "focus",
                syncAuthentication
            );

            document.addEventListener(
                "visibilitychange",
                syncAuthentication
            );

            window.addEventListener(
                AUTH_CHANGED_EVENT,
                syncAuthentication
            );

            return function () {
                window.clearInterval(intervalId);

                window.removeEventListener(
                    "focus",
                    syncAuthentication
                );

                document.removeEventListener(
                    "visibilitychange",
                    syncAuthentication
                );

                window.removeEventListener(
                    AUTH_CHANGED_EVENT,
                    syncAuthentication
                );
            };
        },
        []
    );

    useEffect(
        function () {
            const wasLoggedIn =
                previousLoggedInRef.current;

            if (
                wasLoggedIn === true &&
                loggedIn === false
            ) {
                router.push(
                    "/home",
                    "root",
                    "replace"
                );
            }

            previousLoggedInRef.current = loggedIn;
        },
        [loggedIn, router]
    );

    return (
        <IonTabs>
            <IonRouterOutlet>
                <Route path="/home" component={HomePage} exact />

                <Route
                    path="/tournment"
                    component={TournmentPage}
                    exact
                />

                <Route
                    path="/logIn"
                    component={LogPage}
                    exact
                />

                <Route
                    path="/account"
                    component={AccountPage}
                    exact
                />

                <Route
                    path="/fantasy"
                    component={FantasyPage}
                    exact
                />

                <Route
                    path="/fantasyLeague/:id"
                    component={FantasyLeaguePage}
                    exact
                />

                <Route
                    path="/fantasyTeam/:id"
                    component={FantasyTeamPage}
                    exact
                />

                <Route
                    path="/fantasySettingsMenu/:id"
                    component={FantasySettingsMenuPage}
                    exact
                />

                <Route
                    path="/fantasyPointSettings/:id"
                    component={FantasyPointSettingsPage}
                    exact
                />

                <Route
                    path="/teamSettings/:id"
                    component={TeamSettingsPage}
                    exact
                />

                <Route
                    path="/createLeague"
                    component={CreateLeaguePage}
                    exact
                />

                <Route
                    path="/results/:id"
                    component={ResPage}
                    exact
                />

                <Route
                    path="/calendar/:id"
                    component={CalendarPage}
                    exact
                />

                <Route
                    path="/statsResults/:id"
                    component={StatResPage}
                    exact
                />

                <Route
                    path="/statsTeamResults/:id"
                    component={StatTeamResPage}
                    exact
                />

                <Route
                    path="/game/:id"
                    component={GamePage}
                    exact
                />

                <Route
                    path="/gamePlays/:id"
                    component={GamePlaysPage}
                    exact
                />

                <Route
                    path="/gamePlayers/:id"
                    component={GamePlayersPage}
                    exact
                />

                <Route
                    path="/gameStats/:id"
                    component={GameStatsPage}
                    exact
                />

                <Route
                    path="/team/:id"
                    component={TeamPage}
                    exact
                />

                <Route
                    path="/statsTeam/:id"
                    component={TeamStatsPage}
                    exact
                />

                <Route
                    path="/teamStatsTeam/:id"
                    component={TeamStatsTeamPage}
                    exact
                />

                <Route
                    path="/rosterTeam/:id"
                    component={TeamRosterPage}
                    exact
                />

                <Route
                    path="/table/:id"
                    component={TeamTablePage}
                    exact
                />

                <Route
                    path="/search"
                    component={SearchPage}
                    exact
                />

                <Route
                    path="/player/:id"
                    component={PlayerPage}
                    exact
                />

                <Route
                    path="/statsPlayer/:id"
                    component={StatsPlayerPage}
                    exact
                />

                <Route
                    path="/fantasyDraft/:id"
                    component={FantasyDraftPage}
                    exact
                />

                <Route
                    path="/fantasyGame/:id"
                    component={FantasyGamePage}
                    exact
                />

                <Route
                    path="/leagueSettings/:id"
                    component={FantasySettingsPage}
                    exact
                />

                <Route
                    path="/leagueProjections/:id"
                    component={FantasyProjectionsPage}
                    exact
                />

                <Route
                    path="/fantasyPlayers/:id"
                    component={FantasyPlayersPage}
                    exact
                />

                <Route
                    path="/fantasyDropPlayers/:id"
                    component={FantasyDropPlayersPage}
                    exact
                />

                <Route
                    path="/fantasyTopPlayers/:id"
                    component={FantasyTopPlayersPage}
                    exact
                />

                <Route
                    path="/commissionerTeamSettings/:id"
                    component={FantasyCommissionerTeamSettingsPage}
                    exact
                />

                <Route
                    path="/fantasyDraftSettings/:id"
                    component={FantasyDraftSettingsPage}
                    exact
                />

                <Route
                    path="/commissionerTrades/:id"
                    component={FantasyCommissionerTradesPage}
                    exact
                />

                <Route
                    path="/fantasyScheduleSettings/:id"
                    component={FantasyScheduleSettingsPage}
                    exact
                />

                <Route
                    exact
                    path="/"
                    render={function () {
                        return <Redirect to="/home" />;
                    }}
                />
                
            </IonRouterOutlet>

            <IonTabBar
                slot="bottom"
                className="app-tab-bar"
            >
                <IonTabButton
                    tab="home"
                    href="/home"
                >
                    <IonIcon icon={homeOutline} />
                    <IonLabel>Inicio</IonLabel>
                </IonTabButton>

                <IonTabButton
                    tab="competitions"
                    href="/tournment"
                >
                    <IonIcon icon={trophyOutline} />
                    <IonLabel>Competencias</IonLabel>
                </IonTabButton>

                {/*
                    IMPORTANTE:
                    El tab interno siempre es "session".

                    Sólo cambia href, ícono y texto. Ionic ya no
                    pierde la referencia interna al pasar entre
                    Fantasy e Ingresar.
                
                <IonTabButton
                    tab="session"
                    href={
                        loggedIn
                            ? "/fantasy"
                            : "/logIn"
                    }
                >
                    <IonIcon
                        icon={
                            loggedIn
                                ? americanFootballOutline
                                : personCircleOutline
                        }
                    />

                    <IonLabel>
                        {loggedIn
                            ? "Fantasy"
                            : "Ingresar"}
                    </IonLabel>
                </IonTabButton>*/}
            </IonTabBar>
        </IonTabs>
    );
};

const Tabs: React.FC = () => {
    return (
        <IonReactRouter>
            <TabsContent />
        </IonReactRouter>
    );
};

export default Tabs;
